import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit/typography';

import * as styles from './OpenedPhone.css';

export const OpenedPhone = ({ phone }: { phone: string }) => {
  return (
    <div data-testid="Phone" className={styles['phone']}>
      <UIHeading2>{phone}</UIHeading2>
    </div>
  );
};
